<template>
  <div class="ai-chat-input" :class="{ disabled: !canSend }">
    <div class="input-wrapper">
      <textarea
        ref="textarea"
        v-model="text"
        :placeholder="placeholder"
        :disabled="!canSend"
        :maxlength="10000"
        rows="1"
        @keydown.enter.exact="handleEnter"
        @input="autoResize"
      ></textarea>

      <button
        class="btn-send"
        :disabled="!canSend || !text.trim()"
        @click="send"
      >
        <i v-if="!isStreaming" class="fa-solid fa-paper-plane"></i>
        <b-spinner v-else small variant="light" />
      </button>
    </div>

    <div class="input-footer">
      <span class="char-count" :class="{ warning: text.length > 9500 }">
        {{ text.length }}/10.000
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AIChatInput",
  data() {
    return {
      text: "",
      lastSentAt: 0
    };
  },
  computed: {
    ...mapState("agent", ["isStreaming"]),
    ...mapGetters("agent", ["canSend"]),
    placeholder() {
      if (this.isStreaming) return "Aguarde a resposta...";
      return "Pergunte algo sobre o curso...";
    }
  },
  methods: {
    handleEnter(e) {
      if (e.shiftKey) return;
      e.preventDefault();
      this.send();
    },

    send() {
      const now = Date.now();
      if (now - this.lastSentAt < 1000) return;

      const message = this.text.trim();
      if (!message || !this.canSend) return;

      this.lastSentAt = now;
      this.text = "";
      this.$nextTick(() => this.resetTextarea());
      this.$emit("send", message);
    },

    autoResize() {
      const el = this.$refs.textarea;
      if (!el) return;
      el.style.height = "auto";
      el.style.height = Math.min(el.scrollHeight, 120) + "px";
    },

    resetTextarea() {
      const el = this.$refs.textarea;
      if (el) el.style.height = "auto";
    },

    focus() {
      this.$refs.textarea && this.$refs.textarea.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-chat-input {
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.2);

  &.disabled {
    opacity: 0.7;
  }
}

.input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px 8px 8px 14px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: rgba(171, 133, 229, 0.4);
  }

  textarea {
    flex: 1;
    background: none;
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    line-height: 1.5;
    resize: none;
    max-height: 120px;
    padding: 4px 0;
    font-family: "Noto Sans", sans-serif;

    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }

    &:disabled {
      cursor: not-allowed;
    }
  }
}

.btn-send {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  border: none;
  background: #ab85e5;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 13px;

  &:hover:not(:disabled) {
    background: #9b71d9;
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.input-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
}

.char-count {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.25);

  &.warning {
    color: #e5a085;
  }
}
</style>
